import { useUserInfo as useUserInfoContext } from 'marketing-platform-lib/providers/UserInfoProvider';
export default function useUserInfo() {
  // This hook is called in many components
  // Be careful when adding any computation or memoization here
  return useUserInfoContext();
}